module.exports = __webpack_public_path__ + "img/basketball_c3.0445f9c0.svg";